import { motion } from 'framer-motion';

const COUNTIES = [
  { name: "Total", eligible: "4,561,401", total: "4,483,467", pctReg: "98.29%", active: "4,257,176", pctActive: "93.33%", isTotal: true, over100: true, activeOver: false },
  { name: "Allegany", eligible: "54,562", total: "47,034", pctReg: "86.20%", active: "44,168", pctActive: "80.93%" },
  { name: "Anne Arundel", eligible: "447,561", total: "440,018", pctReg: "98.31%", active: "414,157", pctActive: "92.54%" },
  { name: "Baltimore City", eligible: "429,199", total: "420,450", pctReg: "97.96%", active: "405,207", pctActive: "94.41%" },
  { name: "Baltimore County", eligible: "632,165", total: "599,048", pctReg: "94.76%", active: "581,175", pctActive: "91.93%" },
  { name: "Calvert", eligible: "72,323", total: "73,193", pctReg: "101.20%", active: "69,974", pctActive: "96.75%", over100: true },
  { name: "Caroline", eligible: "24,834", total: "23,389", pctReg: "94.18%", active: "22,453", pctActive: "90.41%" },
  { name: "Carroll", eligible: "134,869", total: "135,075", pctReg: "100.15%", active: "129,649", pctActive: "96.13%", over100: true },
  { name: "Cecil", eligible: "81,507", total: "77,070", pctReg: "94.56%", active: "73,162", pctActive: "89.76%" },
  { name: "Charles", eligible: "128,609", total: "133,518", pctReg: "103.82%", active: "127,268", pctActive: "98.96%", over100: true },
  { name: "Dorchester", eligible: "25,773", total: "24,655", pctReg: "95.66%", active: "23,887", pctActive: "92.68%" },
  { name: "Frederick", eligible: "217,057", total: "216,436", pctReg: "99.71%", active: "205,627", pctActive: "94.73%" },
  { name: "Garrett", eligible: "23,284", total: "21,658", pctReg: "93.02%", active: "20,798", pctActive: "89.32%" },
  { name: "Harford", eligible: "202,948", total: "203,883", pctReg: "100.46%", active: "195,021", pctActive: "96.09%", over100: true },
  { name: "Howard", eligible: "240,291", total: "248,115", pctReg: "103.26%", active: "238,249", pctActive: "99.15%", over100: true },
  { name: "Kent", eligible: "16,334", total: "14,796", pctReg: "90.58%", active: "14,260", pctActive: "87.30%" },
  { name: "Montgomery", eligible: "719,050", total: "739,912", pctReg: "102.90%", active: "694,924", pctActive: "96.64%", over100: true },
  { name: "Prince George's", eligible: "648,807", total: "667,918", pctReg: "102.95%", active: "622,337", pctActive: "95.92%", over100: true },
  { name: "Queen Anne's", eligible: "41,304", total: "42,805", pctReg: "103.63%", active: "41,613", pctActive: "100.75%", over100: true, activeOver: true },
  { name: "Saint Mary's", eligible: "87,034", total: "82,996", pctReg: "95.36%", active: "77,873", pctActive: "89.47%" },
  { name: "Somerset", eligible: "20,343", total: "14,861", pctReg: "73.05%", active: "14,486", pctActive: "71.21%" },
  { name: "Talbot", eligible: "29,726", total: "30,758", pctReg: "103.47%", active: "28,399", pctActive: "95.54%", over100: true },
  { name: "Washington", eligible: "119,423", total: "109,057", pctReg: "91.32%", active: "101,763", pctActive: "85.21%" },
  { name: "Wicomico", eligible: "77,907", total: "70,516", pctReg: "90.51%", active: "67,197", pctActive: "86.25%" },
  { name: "Worcester", eligible: "43,919", total: "46,306", pctReg: "105.44%", active: "43,539", pctActive: "99.13%", over100: true },
];

const VoterInflationData = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">Maryland Voter Roll Inflation vs. National Average</h2>
    <p className="text-slate-600 leading-relaxed mb-6">
      This data highlights Maryland counties where active voter registrations exceed reasonable expectations compared to the national average registration rate of <strong className="text-slate-900">75.60%</strong>. Several counties register over 90%, with some exceeding 100% of eligible voters, <strong className="text-slate-900">signaling a failure to maintain accurate voter rolls in accordance with the NVRA.</strong>
    </p>

    <div className="overflow-x-auto mb-10 rounded-lg border">
      <table className="w-full border-collapse text-[13px]" style={{ minWidth: 800 }}>
        <thead>
          <tr style={{ backgroundColor: '#9E1B32', color: 'white' }}>
            <th className="p-2.5 text-left font-bold">County</th>
            <th className="p-2.5 text-right">Eligible Voters</th>
            <th className="p-2.5 text-right">Total Registered</th>
            <th className="p-2.5 text-right">% Registered</th>
            <th className="p-2.5 text-right">Active Registered</th>
            <th className="p-2.5 text-right">% Active</th>
            <th className="p-2.5 text-right">National Avg</th>
          </tr>
        </thead>
        <tbody>
          {COUNTIES.map((c, i) => (
            <tr key={c.name} style={{
              backgroundColor: c.isTotal ? '#F6BF58' : i % 2 === 0 ? '#f9fafb' : 'white',
              fontWeight: c.isTotal ? 'bold' : 'normal'
            }}>
              <td className="p-2">{c.name}</td>
              <td className="p-2 text-right">{c.eligible}</td>
              <td className="p-2 text-right">{c.total}</td>
              <td className="p-2 text-right" style={c.over100 ? { color: '#9E1B32', fontWeight: 'bold' } : {}}>{c.pctReg}</td>
              <td className="p-2 text-right">{c.active}</td>
              <td className="p-2 text-right" style={c.activeOver ? { color: '#9E1B32', fontWeight: 'bold' } : {}}>{c.pctActive}</td>
              <td className="p-2 text-right">75.60%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">Report Card</h2>
    <p className="text-slate-600 leading-relaxed mb-6">
      This report card provides citizens with scientifically developed data highlighting inaccuracies in the Maryland Voter Registration Database and voting processes. It objectively demonstrates that the Maryland Board of Elections has failed to effectively manage the electoral process and its associated systems.
    </p>

    <iframe
      src="https://docs.google.com/gview?url=https://securethevotemd.com/docs/2024/06/Report-Card-Final-with-MD-Flag.pdf&embedded=true"
      className="w-full rounded-lg border bg-white"
      style={{ height: 800 }}
      title="Maryland Report Card"
    />
    <p className="text-center mt-2 text-sm">
      <a
        href="https://securethevotemd.com/docs/2024/06/Report-Card-Final-with-MD-Flag.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#9E1B32] font-semibold"
      >
        Can't see the PDF? Download it here.
      </a>
    </p>
  </motion.div>
);

export default VoterInflationData;
